<template lang="pug">
  #app
    header-main(v-if="$route.name !== 'login'")
    .wrapper
      router-view
    modal(
      v-if="showModal"
      :showModal="showModal"
    )
</template>

<script>
import HeaderMain from './components/header/index';
import Modal from './components/modal/Modal.vue';
import 'moment/locale/ru';

export default {
  data() {
    return {
      showModal: false,
    };
  },
  components: { HeaderMain, Modal },
  mounted() {
    this.$moment.locale('ru');
    this.$root.$on('toggleModal', ({ target }) => {
      this.showModal = !target.className.includes('popup__close');
    });
    this.$nextTick(() => {
      window.document.title = process.env.VUE_APP_THREAD_NAME
    });
  },
};
</script>

<style lang="stylus">
@import '~normalize.css'

*
  box-sizing border-box
body
  font-family Verdana
  font-size 12px
  background #edeef0
#app
  display flex
  flex-direction column
  height 100vh
.wrapper
  max-width 100%
  margin 0 auto
  display flex
  flex-grow 1
  width 100%
.work-area
  flex-grow 1
  display flex
  flex-direction column
.main-container
  width 100%
  display flex
  align-items center
  background #fff
  border-radius 4px
  padding 1em 1.5em
  margin-bottom 1em
  flex-shrink 0
//scroll
.vb > .vb-dragger {
    z-index: 5;
    width: 12px;
    right: 0;
}

.vb > .vb-dragger > .vb-dragger-styler {
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-transform: rotate3d(0,0,0,0);
    transform: rotate3d(0,0,0,0);
    -webkit-transition:
        background-color 100ms ease-out,
        margin 100ms ease-out,
        height 100ms ease-out;
    transition:
        background-color 100ms ease-out,
        margin 100ms ease-out,
        height 100ms ease-out;
    background-color: rgba(58, 58, 58,.1);
    margin: 5px 5px 5px 0;
    border-radius: 20px;
    height: calc(100% - 10px);
    display: block;
}

.vb.vb-scrolling-phantom > .vb-dragger > .vb-dragger-styler {
    background-color: rgba(58, 58, 58,.3);
}

.vb > .vb-dragger:hover > .vb-dragger-styler {
    background-color: rgba(58, 58, 58,.5);
    margin: 0px;
    height: 100%;
}

.vb.vb-dragging > .vb-dragger > .vb-dragger-styler {
    background-color: rgba(58, 58, 58,.5);
    margin: 0px;
    height: 100%;
}

.vb.vb-dragging-phantom > .vb-dragger > .vb-dragger-styler {
    background-color: rgba(58, 58, 58,.5);
}
.overlay
  position fixed
  left 0
  top 0
  width 100%
  height 100%
  background rgba(0,0,0,.6)
  z-index 50
.pop-up
  position fixed
  left 50%
  top 40%
  transform translate(-50%, -50%)
  background #fff
  border 1px solid #3a3a3a
  font-size 1.4em
  z-index 100
  border-radius 4px
  padding 3em 4em
  text-align center
  &__close
    position absolute
    right 1em
    top 1em
    font-size 1.4em
    cursor pointer
  &__message
    margin-top 1em
  &__btn
    display inline-block
    border 1px solid #3a3a3a
    line-height 2em
    padding 0 1em
    border-radius 4px
    margin 2em 1em 1em
    cursor pointer
    &:hover
      background #edeef0
@media print
{
    .no-print, .no-print *, .post-body__content:after
    {
        display: none !important;
    }
}
</style>
